<template>
  <div class="wrap">
    <div class="flo">
      <div class="t-ae"></div>
      <div class="b-left"></div>
    </div>
    <div class="t-back" @click="handleBack()"></div>
    <div class="share-icon testenter">
      <div class="s-logo"></div>
      <div class="s-icon-2">
        <div class="icon-size ds">
          <img src="../assets/img/ds.png" alt="" srcset="" @click="handleDs('ds')">
        </div>
        <div class="icon-size youtube" @click="handleYoutube('yt')">
          <img src="../assets/img/youtube.png" alt="" srcset="">
        </div>

      </div>
      <div class="s-icon-3">
        <div class="icon-size twi" @click="handleTwi('twi')">
          <img src="../assets/img/twi.png" alt="" srcset="">
        </div>
        <div class="icon-size Instagram" @click="handleInstagram('instagram')">
          <img src="../assets/img/Instagram.png" alt="" srcset="">
        </div>
        <div class="icon-size tiktok" @click="handleTiktok('tiktok')">
          <img src="../assets/img/tiktok.png" alt="" srcset="">
        </div>
      </div>
    </div>
    <!-- 页面 -->
    <home />
    <cha />
    <worldView />
    <story />
    <copyright />
  </div>
</template>

<script>
import home from "./publicComponents/home";
import cha from "./publicComponents/cha";
import worldView from "./publicComponents/worldView";
import story from "./publicComponents/story";
import copyright from "./publicComponents/copyright";

export default {
  name: "Home",
  components: {
    home,
    cha,
    worldView,
    story,
    copyright
  },
  data() {
    return {
      e: "",
    };
  },
  created() { },
  updated() { },
  mounted() {
    window.addEventListener("scroll", this.handleScrollTop, true);
  },
  watch: {},
  computed: {},
  methods: {
    handleDs(val) {
      this.common.goShare(val);
    },
    handleYoutube(val) {
      this.common.goShare(val);
    },
    handleTwi(val) {
      this.common.goShare(val);
    },
    handleInstagram(val) {
      this.common.goShare(val);
    },
    handleTiktok(val) {
      this.common.goShare(val);
    },
    handleBack() {
      this.e.scrollTop = 0
    },
    //滚动事件触发时候会传e 里面有滚动的数据
    handleScrollTop(e) {
      this.e = e.target
    },
  },
  destroyed() {
    //本页面销毁时候，把滚动事件取消掉
    window.removeEventListener("scroll", this.handleScrollTop, true);
  },
};
</script>
<style lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  background: url('../assets/img/bg.jpg');
  position: relative;
  scroll-behavior: smooth;
  background-size: cover;

  .flo {

    position: fixed;
    width: 100%;
    height: 100%;


    .t-ae {
      background: url('../assets/img/t-ae.png') no-repeat;
      width: 181px;
      height: 49px;
      position: absolute;
      top: 34px;
      left: 34px;
      background-size: 100% 100%;
    }



    .b-left {
      background: url('../assets/img/b-left.png') no-repeat;
      width: 116px;
      height: 75px;
      position: absolute;
      bottom: 34px;
      left: 34px;
      background-size: 100% 100%;
    }



  }

  .t-back {
    background: url('../assets/img/t-back.png') no-repeat;
    width: 181px;
    height: 66px;
    position: fixed;
    top: 34px;
    right: 34px;
    background-size: 100% 100%;
    z-index: 1;
    cursor: pointer;
  }

  .share-icon {
    position: fixed;
    bottom: 34px;
    right: 34px;
    z-index: 1;
    display: flex;
    align-items: end;
    gap: 16px;

    img {
      width: 100%;
      height: 100%;
    }

    .s-logo {
      background: url('../assets/img/logo.png') no-repeat;
      width: 166px;
      height: 54px;
      background-size: 100% 100%;
    }

    .icon-size {
      width: 36px;
      height: 36px;
      margin-bottom: 4px;
      cursor: pointer;
    }

  }



  .page-common {
    position: relative;
    z-index: 10;
    width: 100%;
    height: 100%;
    // pointer-events: none;



  }


  &::-webkit-scrollbar {
    width: 2px;
    height: 2px !important;

  }

  &::-webkit-scrollbar-thumb {
    background: transparent;

  }
}
</style>


// WEBPACK FOOTER //
// src/components/MainIndex.vue